import React, { useEffect, useMemo, useState } from "react";
import { formatTeacherDate, teacherApi } from "./teacherApi";
import type { TeacherStudent } from "./types";

const TeacherStudents: React.FC = () => {
  const [students, setStudents] = useState<TeacherStudent[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    teacherApi.myStudents().then(setStudents);
  }, []);

  const filtered = useMemo(() => {
    const text = search.toLowerCase().trim();
    if (!text) return students;
    return students.filter((student) =>
      `${student.name} ${student.email} ${student.phone || ""} ${student.courseTitle || ""} ${student.batchName || ""}`
        .toLowerCase()
        .includes(text)
    );
  }, [students, search]);

  return (
    <div className="space-y-6">
      <section className="rounded-[30px] border border-slate-200 bg-white p-6 shadow-sm">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <p className="text-xs font-black uppercase tracking-wide text-blue-600">My Students</p>
            <h2 className="mt-2 text-3xl font-black text-slate-950">Assigned batch students</h2>
            <p className="mt-2 text-sm font-bold text-slate-500">Teacher ko sirf apne assigned batches ke students dikhne chahiye.</p>
          </div>
          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search student, batch, course..."
            className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold outline-none focus:border-blue-500 lg:w-96"
          />
        </div>
      </section>

      <section className="rounded-[30px] border border-slate-200 bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[850px] text-left">
            <thead>
              <tr className="border-b border-slate-100 bg-slate-50 text-xs font-black uppercase tracking-wide text-slate-400">
                <th className="px-5 py-4">Student</th>
                <th className="px-5 py-4">Course</th>
                <th className="px-5 py-4">Batch</th>
                <th className="px-5 py-4">Payment</th>
                <th className="px-5 py-4">Enrolled</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((student, index) => (
                <tr key={`${student.email}-${index}`} className="border-b border-slate-100 last:border-0 hover:bg-slate-50">
                  <td className="px-5 py-4">
                    <p className="font-black text-slate-950">{student.name}</p>
                    <p className="text-xs font-bold text-slate-500">{student.email}</p>
                    <p className="text-xs font-bold text-slate-400">{student.phone || "-"}</p>
                  </td>
                  <td className="px-5 py-4 text-sm font-bold text-slate-600">{student.courseTitle || "-"}</td>
                  <td className="px-5 py-4 text-sm font-bold text-slate-600">{student.batchName || "-"}</td>
                  <td className="px-5 py-4">
                    <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-black text-emerald-700">
                      {student.paymentStatus || "-"}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-sm font-bold text-slate-500">{formatTeacherDate(student.enrolledAt)}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-5 py-10 text-center text-sm font-bold text-slate-400">
                    No students found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default TeacherStudents;
